
import { Ajax, AjaxError, ISupportSpinner } from '../shared/Ajax';


export class DocumentController extends Ajax {
    constructor() {
        super(window.__emdgBaseUrl, '/api/document');
    }
    
        upload(owner:ISupportSpinner, claimId:string, code:string, itemId:string, multiple:boolean, files:any[], success:{(res:{ [key: string]: string; }):any}, error?:AjaxError) {
    super._call('post', 'Upload', owner, {claimId:claimId,code:code,itemId:itemId,multiple:multiple}, files, success, error)
}

        deleteDocument(owner:ISupportSpinner, claimId:string, documentUniqueId:string, success:{():any}, error?:AjaxError) {
    super._call('delete', 'Delete', owner, {claimId:claimId,documentUniqueId:documentUniqueId}, null, success, error, 'text')
}

        download(owner:ISupportSpinner, claimId:string, documentId:string, success:{():any}, error?:AjaxError) {
    super._call('get', 'Download', owner, {claimId:claimId,documentId:documentId}, null, success, error)
}
}
